var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('el-checkbox',{staticClass:"mr-2 mb-0",model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),(_vm.checked)?_c('small',[_vm._v("Vous avez lu la notification")]):_c('small',[_vm._v("Cochez la case pour indiquer que vous avez lu la notification")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }